module.exports = __webpack_public_path__ + "img/jinrong-bg-2.87b0b5a7.png";